<template>
  <div>
    <!-------- start toast / snackbar------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------- end toast / snackbar------------------->
    <div>
      <!----------------heading nad button  --------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" md="6">
          <h1 class="heading-1">Adverts</h1>
        </v-col>
        <v-col cols="12" md="6">
          <v-card flat class="d-flex align-center justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->
            <v-dialog v-model="add_dialog" persistent max-width="520">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style px-6"
                  depressed
                  v-if="Permission.Add"
                >
                  + Add new Advert
                </v-btn>
              </template>
              <v-card>
                <div class="mx-5 py-5 d-flex justify-space-between">
                  <span class="heading-2"> <b> Add new Advert</b></span>
                  <v-icon @click="add_dialog = false">mdi-close</v-icon>
                </div>

                <div><addadverts-component /></div>
                <div class="d-flex justify-end mx-5 py-5">
                  <v-btn
                    color="#A1A3A8"
                    class="px-14 py-6 text_style"
                    text
                    @click="add_dialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="px-14 py-6 text_style"
                    @click="send()"
                  >
                    <span class="pa-4" v-if="btnloader != true"> Save </span>
                    <v-progress-circular
                      indeterminate
                      v-else
                      size="20"
                      class="px-5"
                      color="white"
                      v-show="btnloader"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
      <!----------------search and filter--------------->
      <v-row class="mt-6">
        <v-col cols="12" class="" md="4" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              v-model="search"
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>
              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Renewaldates"
                      label="By Start Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      class="my-5"
                      dense
                      hide-details
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dates" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenu.save(Renewaldates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-menu
                  ref="datarangemenulast"
                  v-model="datarangemenulast"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldateslast"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Renewaldateslast"
                      label="By End Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      class="my-5"
                      dense
                      hide-details
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateslast" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="datarangemenulast = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenulast.save(Renewaldateslast)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <!-- <v-select
                  outlined
                  v-model="filterPublishdate"
                  :items="filterpubishdateList"
                  dense
                  hide-details
                  label="By Start Date"
                  multiple
                  persistent-hint
                  :menu-props="{ maxHeight: '400' }"
                ></v-select> -->
                <!-- <v-select
                  outlined
                  class="my-5"
                  v-model="filterenddate"
                  :items="filterenddateList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By End Date"
                  multiple
                  persistent-hint
                ></v-select> -->

                <v-select
                  outlined
                  v-model="filterCity"
                  :items="filterCityList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Page "
                  multiple
                  persistent-hint
                ></v-select>
                <v-select
                  :items="['1', '2']"
                  label="By Position"
                  class="mt-5"
                  dense
                  single-line
                  outlined
                ></v-select>

                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="filterDialog = false"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="filterDialog = false"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <!---------------- data table --------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :search="search"
          :items="DataTableOne"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          item-key="index"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ item }">
            <b class="index_index_text"> {{ item.index }} </b>
          </template>

          <template v-slot:[`item.title`]="{ item }">
            <span class="index_head_text"> {{ item.title }} </span>
          </template>
          <template v-slot:[`item.published`]="{ item }">
            <span class="index_head_text"> {{ item.published }} </span>
          </template>
          <template v-slot:[`item.dateend`]="{ item }">
            <span class="index_head_text"> {{ item.dateend }} </span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span class="index_head_text">
              {{ item.display }}
            </span>
          </template>
          <template v-slot:[`item.position`]="{ item }">
            <span class="index_head_text"> {{ item.position }} </span>
          </template>
          <template v-slot:[`item.actions`]>
            <!-- <v-icon small class="mr-2" @click="moreMenu(item)">
            mdi-dots-vertical
          </v-icon> -->

            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="previewDialog = true"
                  >
                    <div flat color="tranparent">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 0V20C3.93 19.5 0 15.21 0 10C0 4.79 3.93 0.5 9 0ZM11.03 0V8.99H20C19.53 4.25 15.76 0.47 11.03 0ZM11.03 11.01V20C15.77 19.53 19.53 15.75 20 11.01H11.03Z"
                          fill="#222222"
                          fill-opacity="0.7"
                        />
                      </svg>
                    </div>
                    <span class="ml-4 text_style">See analytics</span>
                  </v-btn>
                </v-list>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Edit"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="editDialog = true"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-plus-box-multiple</v-icon>
                    <span class="ml-4 text_style">Duplicate</span>
                  </v-btn>
                </v-list>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Delete"
                >
                  <v-list class="px-3 pt-1" color="transparent">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start pl-0"
                      @click="dialog = true"
                    >
                      <v-icon color="#646464">mdi-delete</v-icon>
                      <span class="ml-4 text_style">Delete</span>
                    </v-btn>
                  </v-list>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>
    <!-----------Perview Dialoag-------------->
    <v-dialog v-model="previewDialog" persistent max-width="1020">
      <v-card class="px-9 py-9">
        <div class="d-flex justify-space-between">
          <div>
            <h5>[name_title_advert]</h5>
          </div>
          <div class="d-flex align-center">
            <v-select
              :items="days"
              label="Filter"
              hide-details=""
              style="width: 9vw; margin-right: 1.4vw !important"
              dense
              prepend-inner-icon="mdi-tune"
              single-line
              outlined
            ></v-select>
            <v-icon @click="previewDialog = false" class="mt-n2">
              mdi-close</v-icon
            >
          </div>
        </div>

        <div>
          <analytics-component />
        </div>
      </v-card>
    </v-dialog>
    <!-----------Edit Dialoag-------------->
    <v-dialog v-model="editDialog" persistent max-width="520">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Advert</b></span>
          <v-icon @click="editDialog = false">mdi-close</v-icon>
        </div>

        <div><editads-componet /></div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn
            color="#A1A3A8"
            class="px-14 py-6 text_style"
            text
            @click="editDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="primary" class="px-14 py-6 text_style" @click="send()">
            <span class="pa-4" v-if="btnloader != true"> Save </span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-----------Delete Dialoag-------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="dialog = false">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AddadvertsComponent from "../../components/Ads/addadverts.component.vue";
import AnalyticsComponent from "../../components/Ads/analytics.component.vue";
import EditadsComponet from "../../components/Ads/editads.componet.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AnalyticsComponent,
    EditadsComponet,
    AddadvertsComponent,
    SuccessToastComponent,
  },
  data() {
    return {
      datarangemenu: false,
      datarangemenulast: false,

      //Renewaldates: ["2019-09-10", "2019-09-20"],

      dates: ["2019-09-10", "2019-09-20"],
      dateslast: ["2019-09-10", "2019-09-20"],
      page: 1,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      SuccessToast: false,
      ErrorToast: false,
      singleSelect: false,
      selected: [],
      dialog: false,
      tableLoader: false, // data-table true or false
      add_dialog: false,
      previewDialog: false,
      editDialog: false,
      btnloader: false,
      search: "",
      StartTime: null,
      days: [
        {
          text: "Last week",
        },
        {
          text: "Last month",
        },
      ],
      Filters: [
        {
          text: " Publish date",
        },
        {
          text: " Date end",
        },
        {
          text: "Displayed to",
        },
        // {
        //   text: "Show / Hide",
        // },
        // {
        //   text: "Author",
        // },
        // {
        //   text: "Publisher",
        // },
      ],
      filterTypeEvent: [],
      filterTypeEventList: [
        "Study Group",
        "Public Talk",
        "Expo",
        "Other Event",
      ],
      filterCity: [],
      filterCityList: [
        "Announcements",
        "Blog",
        "Career-Practitioner",
        "Courses-Beginner",
        "Courses-List",
        "Courses-Upcoming",
        "Practitioners",
        "Store",
        "Study Groups & Events",
        "Survey",
      ],
      filterCredential: [],
      filterCredentialList: ["CBP", "CBP-A", "CBI", "MSI"],
      filterMembership: [],
      filterMembershipList: [
        "Starter",
        "Access",
        "Life Science",
        "Standard",
        "Practitioner",
        "Instructor",
      ],

      filterDialog: false,
      headers: [
        { text: "#", value: "index", width: 20 },
        { text: "Name", value: "title", width: 20 },
        { text: "Start Date", value: "published", width: 20 },
        { text: "End Date", value: "dateend", width: 20 },
        { text: "Page", value: "display", width: 20 },
        { text: "Position", value: "position", width: 20 },
        { text: "", value: "actions", sortable: false, width: 20 },
      ],
      DataTableOne: [],
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.DataTableOne.length
        : this.itemsPerPage;
    },

    Renewaldates() {
      return this.dates.join(" to ");
    },
    Renewaldateslast() {
      return this.dateslast.join(" to ");
    },
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Adverts"
    );
    this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: 123,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          dateend: "11/12/2022",
          position: "1",
          display: "Store page",
        },
        {
          index: 1,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          dateend: "11/12/2022",
          position: "1",
          display: "Store page,Product_detail_page,BodyTalk Access",
        },
        {
          index: 2,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          dateend: "-",
          position: "1",
          display: "Store page,BodyTalk Access",
        },
        {
          index: 3,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          dateend: "-",
          position: "2",
          display:
            "Store page,Product_detail_page,Practitioner page,[article_name],BodyTalk Access",
        },
        {
          index: 4,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          dateend: "-",
          position: "2",
          display: "Store page,[article_name],BodyTalk Access",
        },
        {
          index: 5,
          title: "[name_advert]",
          status: "DeniedAgreement",
          published: "11/12/2021",
          dateend: "11/12/2022",
          position: "1",
          display: "Store page,Product_detail_page",
        },
        {
          index: 6,
          title: "[name_advert]",
          status: "PendingAgreement",
          published: "11/12/2021",
          dateend: "11/12/2022",
          display: "Store page,BodyTalk Access",
          position: "1",
        },
        {
          index: 7,
          title: "[name_advert]",
          status: "DeniedAgreement",
          position: "2",
          published: "11/12/2021",
          dateend: "11/12/2022",
          display: "Store page,Product_detail_page,Practitioner page",
        },
        {
          index: 8,
          title: "[name_advert]",
          status: "Accepted",
          published: "11/12/2021",
          position: "2",
          dateend: "11/12/2022",
          display: "[article_name],BodyTalk Access",
        },
        {
          index: 9,
          title: "[name_advert]",
          position: "1",
          status: "DeniedAgreement",
          published: "11/12/2021",
          dateend: "11/12/2022",
          display: "Store page,[article_name],BodyTalk Access",
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
  },
  methods: {
    cleanFilter() {
      this.filterTypeEvent = null;
      this.filterModality = null;
      this.filterDate = null;
      this.filterTypeModality = null;
    },
    DdialogClose() {
      this.dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.btnloader = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.SuccessToast = false;
      this.ErrorToast = false;
    },
  },
};
</script>

<style scoped>
#chip.v-chip.Accepted {
  background: #e7f3d3;
  padding: 0 7%;
  color: #61b257;
  margin: 0 7%;
}
#chip.v-chip.PendingAgreement {
  background: #e8f3fa;
  padding: 0 7%;
  color: #3a91cc;
}
#chip.v-chip.DeniedAgreement {
  background: #fcf6e6;
  padding: 0 7%;
  color: #d18911;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
